import React from 'react'
import {
  AdCreative,
  AdCreativeStatus,
  CampaignGoalType,
  PublishCampaignDTO,
} from '@marketing-milk/interfaces'
import { equals } from 'lodash/fp'
import { useEffect, useState } from 'react'
import {
  creativeHasValidLeadCard,
  hasImproperCTA,
  isValidCreative,
} from '../../../campaigns/helpers/campaign.helpers'
import { AdCreativeList } from './'

type Props = {
  creatives?: AdCreative[]
  selectedCreatives: AdCreative[]
  campaignDto: PublishCampaignDTO
  onChangeCreatives: (creatives: AdCreative[]) => void
  fetchNextPage?: () => void
  hasNextPage?: boolean
  isFetchingNextPage?: boolean
  isFetching?: boolean
  skipCreativeValidation?: boolean
}

export function AdCreativeStep({
  campaignDto,
  selectedCreatives,
  onChangeCreatives,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  isFetching,
  skipCreativeValidation,
  ...props
}: Props) {
  const [creatives, setCreatives] = useState(props.creatives)

  useEffect(() => {
    if (!props.creatives) return
    setCreatives(filterCreatives(props.creatives))
  }, [props.creatives])

  const filterCreatives = (creatives: AdCreative[]) => {
    if (skipCreativeValidation) return creatives
    return creatives
      .filter(creative => creative.status !== AdCreativeStatus.DELETED) // not deleted
      .filter(creative => creative.status !== AdCreativeStatus.WITH_ISSUES) // has no issues
      .filter(creative => !hasImproperCTA(creative, campaignDto.campaign.goal)) // doesn't have config issues with campaign optimization
      .filter(creative =>
        campaignDto.campaign.goal === CampaignGoalType.LeadGeneration
          ? creativeHasValidLeadCard(creative)
          : true
      )
      .filter(creative => isValidCreative(creative))
  }

  const selectCreative = (newCreative: AdCreative) => {
    const alreadySelected = selectedCreatives.some(c => equals(c, newCreative))
    if (alreadySelected) {
      onChangeCreatives(selectedCreatives.filter(c => !equals(c, newCreative)))
    } else if (selectedCreatives.length < 26) {
      onChangeCreatives([...selectedCreatives, newCreative])
    }
  }

  return (
    <AdCreativeList
      creatives={creatives}
      selectedCreatives={selectedCreatives}
      selectCreative={selectCreative}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      isFetching={isFetching}
    />
  )
}
